module.exports = __webpack_public_path__ + "static/KCC-20be13ce72cd885dd5791b8408fea46f.png";